import { render, staticRenderFns } from "./AddNode2.vue?vue&type=template&id=081c0f1e"
import script from "./AddNode2.vue?vue&type=script&lang=js"
export * from "./AddNode2.vue?vue&type=script&lang=js"
import style0 from "./AddNode2.vue?vue&type=style&index=0&id=081c0f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports